import { Route, Routes } from "react-router-dom";
import routes from "./Route";
import Layout from "../Layout/Layout";
import webservice from "../Service/webservice";
import { useEffect, useState } from "react";
import { AesDecrypt, keyPromise } from "../Service/crypto";
import ContactAdmin from "./ContactAdmin";
import api from "../api";


interface RouteType {
  path: string;
  Component: React.ReactNode;
}

// Always reachable regardless of AppMenu/Menu_Details permission data — for screens that are
// still being built out and shouldn't depend on a menu/permission record existing yet.
const ALWAYS_ACCESSIBLE_PATHS = ['/templateCreation/formDesigner'];

const LayoutRoutes = () => {

  const login = localStorage.getItem("login");
  const [filteredRoutes, setFilteredRoutes] = useState<RouteType[]>([]);

  useEffect(() => {
    const fetchPermissions = async (data: any) => {
      try {
        const key = await keyPromise;

        const [excludedPathsResponse, urlPermissionResponse] = await Promise.all([
          api.fetch('api/AppMenu/GetExcludedPaths'),
          api.fetch('api/AppMenu/GetUrlPermission', {
            method: 'POST',
            body: JSON.stringify({ data }),
          }),
        ]);

        let excludedPaths: string[] = [];
        if (excludedPathsResponse.ok) {
          const responseData = await excludedPathsResponse.json();
          excludedPaths = await AesDecrypt(key, responseData);
        } else {
          excludedPaths = ['/users/usersprofile', '/clientManagement/addClientadmin', '/clientManagement/editClientadmin', '/addvendoradmin', '/editvendoradmin', '/addTeam', '/editTeam', '/users/changepassword', '/templateCreation/FieldMaster', '/managelabel', '/addpayor', '/editpayor', '/addonder', '/editonder', '/insurance', '/addinsurance', '/editinsurance', '/templateCreation/formDesigner'];
        }

        if (urlPermissionResponse.ok) {
          const responseData = await urlPermissionResponse.json();
          localStorage.setItem("Permission", JSON.stringify(responseData));
          const filtered = routes.filter(route => {
            const path = "/" + route.path;
            if (excludedPaths.includes(path) || ALWAYS_ACCESSIBLE_PATHS.includes(path)) {
              return true;
            }

            const hasPermission = responseData.some((permission: any) =>
              (permission.Menu_url === path || permission.Add_Url === path || permission.Edit_Url === path || route.path.includes(':')) &&
              (permission.Menu_Action.includes('view') || permission.Menu_Action.includes('add') || permission.Menu_Action.includes('edit'))
            );

            return hasPermission;
          });
          setFilteredRoutes(filtered);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const data = localStorage.id;

    if (data !== undefined && login) {
      fetchPermissions(data);
    }
  }, [login]);


  return (
    <>
      <Routes>
        {filteredRoutes.map(({ path, Component }: any, i) => (
          <Route element={<Layout />} key={i}>
            <Route path={path} element={Component} />
            <Route path={"*"} element={<ContactAdmin />} />
          </Route>
        ))}
      </Routes>
    </>
  );
};

export default LayoutRoutes;
